if (!customElements.get('product-form')) {
  function transformKey(key) {
    if (key == 'befestigungs_typ') return 'Montagevariante';
    if (key == 'plissee_typ') return 'Plisseemodell';
    let changedKey = key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();
    changedKey = changedKey.replace(/_/g, '');
    changedKey = changedKey.replace('Hoehe', 'Höhe');
    return changedKey;
  }

  function transformValue(value) {
    let valuesDictionary = [
      { original: 'direkt_vor_der_scheibe', transformed: 'in der Glasleiste' },
      { original: 'stick_fix', transformed: 'mit Stick&Fix (bohrfrei)' },
      { original: 'am_fensterfluegel', transformed: 'mit Winkeln' },
      { original: 'klemmtraeger', transformed: 'mit Klemmträgern (bohrfrei)' },
      { original: 'klemmtraeger_slim', transformed: 'mit Slim-Klemmträgern (bohrfrei)' },
      { original: 'stick_fix_front', transformed: 'mit Stick&Fix Front (bohrfrei)' },
      { original: 'gelenkklebeplatten', transformed: 'mit Gelenkklebeplatten (bohrfrei)' },
      { original: 'klebeleisten', transformed: 'mit Klebeprofilen auf der Scheibe (bohrfrei)' },
      { original: 'glasleistenwinkel', transformed: 'mit Glasleistenwinkeln' },
      { original: 'falzfix', transformed: 'mit Falzfix (bohrfrei)' },
      { original: 'am_mauerwerk', transformed: 'mit Winkeln an der Wand' },
      { original: 'clip', transformed: 'mit Clips' },
      { original: 'winkel', transformed: 'mit Winkeln' },
      { original: 'montageprofil_mit_winkeln', transformed: 'Montageprofile mit Montagewinkeln' },
      { original: 'montageprofil_haltebolzen', transformed: 'Montageprofile mit Haltebolzen' },
    ];
    for (let entry of valuesDictionary) {
      if (entry.original === value) {
        return entry.transformed;
      }
    }
    let changedValue = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    return changedValue;
  }

  function createInput(key, value) {
    // Lets first determine if the input with a given key exist.
    // If so, we dont need to create it again. We can just update its value.
    // const existingInput = document.querySelector(`input[name="properties[${key}]"]`);
    // if (existingInput) {
    //     existingInput.value = value;
    //     console.log(`Input with key '${key}' already exists, so we just updated value.`);
    // } else {

    const inputsOutputPositions = document.querySelectorAll('input.product-variant-id');
    for (let i = 0; i < inputsOutputPositions.length; i++) {
      const input = document.createElement('input');
      input.type = 'hidden'; //maybe we need to change it later
      console.log(transformKey(key));
      input.name = 'properties[' + transformKey(key) + ']';
      input.value = transformValue(value);

      const element = inputsOutputPositions[i];
      element.insertAdjacentElement('afterend', input);
    }
  }

  function createInputsFromRawData(rawData) {
    const ignoreList = ['product_id', 'quantity', 'price'];
    for (const key in rawData) {
      if (rawData.hasOwnProperty(key) && !ignoreList.includes(key)) {
        const value = rawData[key];
        createInput(key, value);
      }
    }
  }

  function topAddToCartSubmit(e) {
    let errorMessageExist = document.querySelector('.error_message');
    let masseTopContainer = document.querySelector('.sizes_section_anchor');
    let activeSizeInputs = document.querySelectorAll('.size_input');
    let errorInputsArray = [];
    for (let i = 0; i < activeSizeInputs.length; i++) {
      let inputElemId = activeSizeInputs[i].getAttribute('id');
      if (activeSizeInputs[i].value == '' || activeSizeInputs[i].value == 'undefined') {
        let errorElem = inputElemId;
        errorInputsArray.push(errorElem);
      }
    }

    //if errorInputsArray is not empty (meaning we dont have required input data that should be present)
    //or there are at least one error message present (wrong data was entered)
    //prevent data from posting to backend + scroll to massee section
    if (JSON.stringify(errorInputsArray) !== '[]' || errorMessageExist) {
      e.preventDefault();
      for (let i = 0; i < errorInputsArray.length; i++) {
        document.getElementById(errorInputsArray[i]).classList.add('validation_error');
      }
      if (masseTopContainer) {
        masseTopContainer.scrollIntoView({
          behavior: 'smooth',
        });
      }
      return true;
    } else {
      return false;
    }
  }

  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        console.log('Reached onSubmitHandler');
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        //-------------------------------
        // add delphinus
        //-------------------------------

        const configuratorPriceElement = document.querySelector('.final_price');

        if (configuratorPriceElement) {
          this.submitButton.setAttribute('aria-disabled', true);

          let errorsPresent = topAddToCartSubmit(evt);
          if (errorsPresent) {
            this.submitButton.removeAttribute('aria-disabled');
            return;
          };

          // 1. delete VariantID in order to avoid adding an old / wrong variant in case the addToCart-Request fails
          let inputsWithVariantId = document.querySelectorAll('input.product-variant-id');
          console.log('reset variantIDs');
          for (let i = 0; i < inputsWithVariantId.length; i++) {
            const element = inputsWithVariantId[i];
            element.value = '';
          }

          let raw = {
            product_id: '8770453569877',
            quantity: 1,
          };

          raw['product_id'] = document.querySelector('input[name="product-id"]').value;
          raw['quantity'] = document.querySelector('.quantity .quantity__input').value;

          const priceText = document.querySelector('.final_price').textContent;
          // Remove the euro symbol and any spaces, then replace the comma with a period (if necessary)
          const cleanedPriceText = priceText.replace(/[^\d,.-]/g, '').replace(',', '.');
          // Convert the cleaned text into a float number
          raw['price'] = parseFloat(cleanedPriceText);
          console.log('parseFloat(cleanedPriceText)', parseFloat(cleanedPriceText));

          let radioInputs = document.querySelectorAll('.option_item input[type="radio"]:checked');
          let sizeInputs = document.querySelectorAll('input.size_input');
          let selectInputs = document.querySelectorAll('select.size_input');

          function populateData(inputs) {
            inputs.forEach(function (input) {
              let key = input.name;
              let value = input.value.toString(); // Convert the value to a string
              raw[key] = value;
            });
          }

          populateData(sizeInputs);
          populateData(radioInputs);
          populateData(selectInputs);

          //check should be here

          console.log('Raw data:', raw);

          let myHeaders = new Headers();
          myHeaders.append('Content-Type', 'application/json');
          let requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(raw),
            redirect: 'follow',
          };

          fetch('https://shop.plissee-zauber.de/addToCart', requestOptions)
            .then((response) => {
              console.log('1', response);
              console.log('2', response.status);
              console.log('3', response.body);
              return response.text();
            })
            .then((result) => {
              try {
                // Parse the JSON response
                console.log('Trying to parse JSON response');
                const jsonResponse = JSON.parse(result);
                console.log('Parsed JSON response:', jsonResponse);
                console.log('Parsed JSON response body:', jsonResponse);
                if (jsonResponse.hasOwnProperty('variantId')) {
                  const variantId = jsonResponse.variantId;
                  console.log('This is ok, build an input');
                  console.log('Response variantID : ' + variantId);
                  // document.querySelector('input.product-variant-id').value = variantId;
                  let inputsWithVariantId = document.querySelectorAll('input.product-variant-id');
                  for (let i = 0; i < inputsWithVariantId.length; i++) {
                    const element = inputsWithVariantId[i];
                    element.value = variantId;
                  }
                } else {
                  console.log('Non-200 status. Throwing error.');
                  //non-200 status
                  throw new Error('Request failed with status: ' + jsonResponse.error);
                }
              } catch (error) {
                console.error('JSON parsing error:', error);
              }

              //
              console.log('Calling createInputsFromRawData');
              createInputsFromRawData(raw);
              //----------------------------------------------
              // continue with "original code" aka form submit
              //----------------------------------------------
              this.basicFormSubmit();
            })
            .catch((error) => {
              console.error('An error occurred:', error);
              console.log('Error location:', error.stack);
              event.preventDefault();
            });
        } else {
          //-------------------------------------------
          // If a product is NOT a configurator - use
          // default submit functionality
          //-------------------------------------------
          this.basicFormSubmit();
        }
      }

      //-------------------------------------------
      // default shopify form submit functionality
      //-------------------------------------------
      basicFormSubmit() {
        console.log('basicFormSubmit is running');
        // if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        console.log('Reached handleErrorMessage');
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector(".loading__spinner").classList.remove(
            "hidden"
          );

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        console.log('Fetching config:', config);
        console.log('Form data:', formData);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log('Response:', response);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector(".loading__spinner").classList.add(
                "hidden"
              );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
